import { takeEveryApiCall } from 'syft-acp-core/sagas/helpers'

import { listAgencyShifts } from './api'

export default function* root() {
  yield takeEveryApiCall('AGENCY_SHIFTS_FETCH', listAgencyShifts)
}
